/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Trending',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M20.924 5.576A.59.59 0 0 0 20.5 5.4h-4a.6.6 0 1 0 0 1.2h2.552L12.7 12.952l-2.576-2.576a.6.6 0 0 0-.849 0l-7.2 7.2a.6.6 0 0 0 .849.848L9.7 11.649l2.576 2.576a.6.6 0 0 0 .848 0L19.9 7.449V10a.6.6 0 1 0 1.2 0V6a.59.59 0 0 0-.176-.424z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
